"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.deviceWarranty = deviceWarranty;
var _intervalToDuration = _interopRequireDefault(require("date-fns/intervalToDuration"));
var _sortedGroups = require("./actions/sortedGroups");
var _jsxRuntime = require("react/jsx-runtime");
function setHrMinSecMill(date, value) {
  date.setHours(value);
  date.setMinutes(value);
  date.setSeconds(value);
  date.setMilliseconds(value);
  return date;
}
function yearMonthReducer(dateTime) {
  // {"years":0,"months":0,"days":11,"hours":13,"minutes":46,"seconds":40}
  const duration = (0, _intervalToDuration.default)({
    start: setHrMinSecMill(new Date(dateTime), 0),
    end: setHrMinSecMill(new Date(), 0)
  });
  let {
    years,
    months,
    days,
    hours,
    minutes,
    seconds
  } = duration;
  let year, month, day, hasYearMonth, hasYearOrMonth;
  if (years === 1) {
    // plural to singular
    years = 0;
    year = 1;
  }
  if (months === 1) {
    // plural to singular
    months = 0;
    month = 1;
  }
  if (days === 1 || days <= 0 && (hours > 0 || minutes > 0 || seconds > 0)) {
    // plural to singular
    days = 0;
    day = 1;
  }

  // display logic booleans
  if ((years >= 1 || year >= 1) && (months >= 1 || month >= 1)) {
    hasYearMonth = true;
  } else if (years >= 1 || year >= 1 || months >= 1 || month >= 1) {
    hasYearOrMonth = true;
  }
  return {
    years,
    year,
    months,
    month,
    days,
    day,
    hours,
    minutes,
    seconds,
    hasYearMonth,
    hasYearOrMonth
  };
}
function formText(value, text, secValue, secText) {
  // checks 2 truthy values
  // truthy values returns text replaced with value
  // un-truthy returns empty string
  return value ? text.replace('{{value}}', value) : secValue ? secText.replace('{{value}}', secValue) : '';
}
function warrantyText(labels, config, duration) {
  const {
    years,
    year,
    months,
    month,
    days,
    day,
    hasYearMonth,
    hasYearOrMonth
  } = duration;
  const {
    abbrSingleYear,
    abbrPluralYear,
    singleYear,
    pluralYear,
    abbrSingleMonth,
    abbrPluralMonth,
    singleMonth,
    pluralMonth,
    singleDay,
    pluralDay
  } = config;
  if (hasYearMonth) {
    // forms text from year or years
    const yearText = formText(year, labels[abbrSingleYear], years, labels[abbrPluralYear]);
    // forms text from month or months
    const monthText = formText(month, labels[abbrSingleMonth], months, labels[abbrPluralMonth]);
    return `${yearText} ${monthText}`;
  }
  if (hasYearOrMonth) {
    // forms text from year or years if truthy else ''
    const yearText = formText(year, labels[singleYear], years, labels[pluralYear]);
    // forms text from month or months if truthy else ''
    const monthText = formText(month, labels[singleMonth], months, labels[pluralMonth]);

    // one contain empty string the other text.
    return `${yearText}${monthText}`;
  }
  const dayText = formText(day, labels[singleDay], `${days}`, labels[pluralDay]);
  // one contain empty string the other text.
  return `${dayText}`;
}
function deviceWarranty(labels, data = {}) {
  const {
    warrantyOptions,
    timestamp,
    ...config
  } = data;
  const warranty = warrantyOptions.find(({
    option
  }) => (0, _sortedGroups.findSortedGroupOption)(timestamp, option));
  if (warranty) {
    const value = (warranty == null ? void 0 : warranty.value) && labels[warranty == null ? void 0 : warranty.value] || warrantyText(labels, config, yearMonthReducer(timestamp));
    const style = warranty.option.split('.').pop();
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: `ccl-e-device-warranty ccl-e-device-warranty--${style}`,
      children: value
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "ccl-e-device-warranty"
  });
}